import * as constants from "./constants";

const initialState = {
  fetchingLoading: false,
  updateLoading: false,
  isAdding: false,
  loginOption: null,
};

const loginOptionReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_LOGIN_OPTIONS:
      return {
        ...state,
        fetchingLoading: true,
      };
    case constants.FETCH_LOGIN_OPTIONS_SUCCESS:
      return {
        ...state,
        fetchingLoading: false,
        loginOption: action.payload,
      };
    case constants.FETCH_LOGIN_OPTIONS_ERROR:
      return {
        ...state,
        fetchingLoading: false,
        loginOption: null,
      };

    case constants.CREATE_LOGIN_OPTIONS:
      return {
        ...state,
        updateLoading: true,
      };

    case constants.CREATE_LOGIN_OPTIONS_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        loginOption: action.payload,
        isAdding: false,
      };

    case constants.CREATE_LOGIN_OPTIONS_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
      };

    default:
      return state;
  }
};

export default loginOptionReducer;
